import axios from 'axios';
import { accessTokenStore } from 'entities/index';
import { LoadingStatusEnum } from 'shared/types';

const instance = (baseURL: any) => {
  const API = axios.create({
    withCredentials: true,
    baseURL: baseURL,
  });
  const authInterceptors = async (config: any) => {
    if (
      !config.skipTokenWait &&
      accessTokenStore.isLoadingTokenStatus === LoadingStatusEnum.LOADING
    ) {
      await accessTokenStore.waitForToken();
    }
    const token = accessTokenStore.getAccessToken();
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  };

  API.interceptors.request.use(authInterceptors);

  API.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response?.status === 401 &&
        !error.config?.url?.includes('/auth/refresh') &&
        !error.config?.url?.includes('/auth/sign-in')
      ) {
        accessTokenStore.clear();
        window.location.href = '/';
      }
      return Promise.reject(error);
    }
  );

  return API;
};

export { instance };
